
import React, { Fragment, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as Error } from "../../assets/utils/images/svgs/ErrorPage.svg";

const Forbidden = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const timer = setTimeout(() => {

            navigate("/login", { replace: true });
        }, 4000);

        return () => {
          
            clearTimeout(timer);
        };
    }, [navigate, location.pathname, location.state]);

    return (
        <Fragment>
            <div className="position-absolute top-50 start-50 translate-middle">
                <div className="fs-3 fw-bolder">
                    <Error />
                </div>
            </div>
        </Fragment>
    );
};

export default Forbidden;
